module.exports = __webpack_public_path__ + "static/media/check.ca842ed8.png";


//////////////////
// WEBPACK FOOTER
// ./src/workout/check.png
// module id = 2037
// module chunks = 0